function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageRefresh = function SvgImageRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    viewBox: "0 0 34 34",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M16.994 1C25.82 1 33 8.178 33 17s-7.18 16-16.006 16C8.344 33 1.279 26.105 1 17.526l4.079-.847c-.003.108-.017.213-.017.321 0 6.576 5.353 11.928 11.932 11.928S28.926 23.576 28.926 17 23.573 5.072 16.994 5.072c-3.054 0-5.83 1.169-7.942 3.062l3.886 3.233-11.229 2.62.539-11.511 3.637 3.025A15.95 15.95 0 0 1 16.994 1",
    style: {
      strokeWidth: 1.00102
    }
  }));
};
export { SvgImageRefresh as ReactComponent };
export default __webpack_public_path__ + "assets/ImageRefresh.f57676118d00ceffedb1cedd8902a64a.svg";